import adminApi from './adminApi';
import { unwrapApiResponse } from './apiUtils';
import type {
  AdminContentModuleResponse,
  ContentItem,
  ContentModuleKey,
  UploadedFilePayload,
} from '../types/content';
import type { ApiResponse } from '../types/api';

type CreateOrUpdatePayload = Record<string, unknown> & {
  file?: UploadedFilePayload;
};

export async function fetchAdminContentModule<TItem extends ContentItem = ContentItem>(
  moduleKey: ContentModuleKey
) {
  const response = await adminApi.get<ApiResponse<AdminContentModuleResponse<TItem>>>(`/content/${moduleKey}`);
  return unwrapApiResponse(response);
}

export async function createAdminContentItem<TItem extends ContentItem = ContentItem>(
  moduleKey: ContentModuleKey,
  payload: CreateOrUpdatePayload
) {
  const response = await adminApi.post<ApiResponse<{ item: TItem; updatedAt: string }>>(
    `/content/${moduleKey}`,
    payload
  );
  return unwrapApiResponse(response);
}

export async function updateAdminContentItem<TItem extends ContentItem = ContentItem>(
  moduleKey: ContentModuleKey,
  itemId: string,
  payload: CreateOrUpdatePayload
) {
  const response = await adminApi.put<ApiResponse<{ item: TItem; updatedAt: string }>>(
    `/content/${moduleKey}/${itemId}`,
    payload
  );
  return unwrapApiResponse(response);
}

export async function deleteAdminContentItem(moduleKey: ContentModuleKey, itemId: string) {
  const response = await adminApi.delete<ApiResponse<{ ok: boolean; updatedAt: string }>>(
    `/content/${moduleKey}/${itemId}`
  );
  return unwrapApiResponse(response);
}

export async function reorderAdminContentItems<TItem extends ContentItem = ContentItem>(
  moduleKey: ContentModuleKey,
  ids: string[]
) {
  const response = await adminApi.put<ApiResponse<AdminContentModuleResponse<TItem>>>(`/content/${moduleKey}/order`, {
    ids,
  });
  return unwrapApiResponse(response);
}
